/** Helper functions **/
function isEmpty(el) {
	var $el = el instanceof jQuery ? el : $(el);
	return !$.trim($el.html());
}

const breakpointForMobileNav = 1050;
const breakpointTablet = 1024;
const breakpointMobile = 500;
const breakpointAnchorNavHorizontalList = 1638;
var animationInterval;


function openInNewTab(url) {
	var win = window.open(url, '_blank');
	win.focus();
}


function calculateAnchorOffset() {
	let offset = 100;

	if (window.innerWidth <= breakpointAnchorNavHorizontalList) {
		let $anchorNavList = $('.js-anchor-nav-list');
		if ($anchorNavList.length > 0) {
			offset = $('.page-nav').outerHeight() + $anchorNavList.outerHeight() + offset / 2;
		}
	}

	return offset;
}

function scrollToHash($hash, animationTime = 900, callback = null) {

	if ($hash.length <= 0) {
		return;
	}

	var offset = calculateAnchorOffset();
	var topPosition = $hash.offset().top - offset;

	$('html, body').animate({
		scrollTop: topPosition
	}, animationTime, 'swing', _ => {
		if (callback) {
			callback();
		}
	});
}

$(document).ready(function () {

	// handle preselection of select for jobs
	handlePreselectionOfJobSelect();

	// data prodtection for social media links
	var $dataProtectionSocialMedia = $('.js-data-protection-social-media');
	var clickedLinkHref;
	$('a').on('click', function (event) {
		clickedLinkHref = $(this).attr('href');
		if (clickedLinkHref.includes('instagram') || clickedLinkHref.includes('facebook') || clickedLinkHref.includes('youtube')) {
			event.preventDefault();
			$dataProtectionSocialMedia.attr('href', clickedLinkHref);
			$dataProtectionSocialMedia.show();
		}
	});

	$('.js-data-protection-social-media-reject').on('click', function () {
		$('.js-data-protection-social-media').hide();
	});

	$('.js-data-protection-social-media-confirm').on('click', function () {
		if (clickedLinkHref) {
			openInNewTab(clickedLinkHref);
		}
		$('.js-data-protection-social-media').hide();
	});

	$('.js-language-changer').on('click', function () {
		$('.js-language-changer').toggleClass('is-open');
		$('.body').toggleClass('language-changer-is-open');
	})

	// anchor-navigation
	$('.frame').each((iteratee, section) => {
		let sectionObserver = new IntersectionObserver(
			intersectionCallbackForNavigation, {
				root: null,
				rootMargin: '0px',
				threshold: 0.1
			}
		)
		sectionObserver.observe(section);
	})

	$('.js-anchor-nav-link').on('click', function (e) {
		e.preventDefault();
		let href = $(this).attr('href');
		let id = href.substring(href.indexOf('#'), href.length);
		scrollToHash($(id));
	})

	initContentChange();
	updateContent();

	$(window).resize(function () {
		updateContent();
	});

	function updateContent() {
		setAnimationOfAnimatedImgContainer();
		setNavWidthToLvl3Content();
		hidePageBorderAfterContentChange();
		initDragScroll();
		updateTable();
		closeDropdownOnMobile();
		setAnchorNavBehaviour();
		// Update anchor nav position on resize
		if ($('body').hasClass('page-is-scrolled')) {
			updateAnchorNavPosition();
		}
	}

})

// anchor-navigation
function setAnchorNavBehaviour() {
	let anchorNaviWidth = 0;
	$('.js-anchor-nav').each(function (i, nav) {
		$(nav).find('.js-anchor-nav-link').each(function (i, navLink) {
			anchorNaviWidth = anchorNaviWidth + $(navLink).outerWidth(true);
		})
		if (anchorNaviWidth < window.innerWidth) {
			$(nav).addClass('is-center has-auto-scrolling');
		}
	})
}

function intersectionCallbackForNavigation(entries) {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			let $navLinkOfAnchorNav = getNavLinkOfAnchorNav($(entry.target));
			if ($navLinkOfAnchorNav) {
				updateAnchorNav($navLinkOfAnchorNav)
			}
		}
	});
}

function getNavLinkOfAnchorNav($el) {
	let id = $el.attr('id');
	if (id) {
		let navLinkOfAnchorNav = false;
		$('.js-anchor-nav-link').each(function (i, navLink) {
			if (!navLinkOfAnchorNav) {
				let $navLink = $(navLink);
				if ($navLink.length > 0) {
					if ($navLink.attr('href').includes(id)) {
						navLinkOfAnchorNav = $navLink;
					}
				} else {
					navLinkOfAnchorNav = false;
				}
			}
		})
		return navLinkOfAnchorNav;
	} else {
		return false;
	}
}

function updateAnchorNav($newActiveElement) {
	let activeClass = 'is-active';
	$('.js-anchor-nav-link').removeClass(activeClass);
	$newActiveElement.addClass(activeClass);
	if (window.innerWidth <= breakpointForMobileNav) {
		centerTabLink($newActiveElement, '.js-anchor-nav-list', null);
	} else if ($newActiveElement.closest('.js-anchor-nav').hasClass('has-auto-scrolling')) {
		centerTabLink($newActiveElement, '.js-anchor-nav-list', null);
	}
}


// animated-img-container
function setAnimationOfAnimatedImgContainer() {

	var $animatedImgContainer = $('.js-animated-img-container');

	if (window.innerWidth <= breakpointForMobileNav) {

		if ($animatedImgContainer.hasClass('is-animated')) {
			return;
		}

		$animatedImgContainer.addClass('is-animated')
		animationInterval = automaticAnimation();

	} else {
		if (animationInterval) {
			clearInterval(animationInterval);
		}
		$('.overlay').removeClass('visible');
		$animatedImgContainer.removeClass('is-animated')
	}

}

function automaticAnimation() {
	var lis_count = $('.overlay').length;
	var active_li_index = 0;

	return setInterval(function () {
		var activeClass = 'visible';
		var overlaySelector = '.overlay';
		var activeOverlaySelector = overlaySelector + '.' + activeClass;

		if ($(activeOverlaySelector).index() == lis_count - 1)
			active_li_index = 0;
		else
			active_li_index++;

		$(activeOverlaySelector).removeClass(activeClass);
		$(overlaySelector).eq(active_li_index).addClass(activeClass);
	}, 1500);
}

// content-navigation
function setNavWidthToLvl3Content() {
	var padding = 20;

	$('.js-content-navigation').each(function (i, nav) {
		var $nav = $(nav);
		var $subNavContentWrapper = $nav.find('.js-sub-menu > ul');
		var navWidth = $nav.innerWidth();

		var width = navWidth - padding * 2;

		if (window.innerWidth > 1231) {
			width = navWidth - padding * 3.5;
		}

		$subNavContentWrapper.css('width', width + 'px');
	})
}

// mobile navigation scripts
function toggleNav() {
	if ($('.nav-wrap').hasClass('nav-active')) {
		// is open
		closeNav();
		removePageCover();
	} else {
		// is close
		coverPage();
		openNav();
	}
}

function openNav() {
	$('.nav-wrap').addClass('nav-active');
	$('.nav-opener').addClass('is-active');
}

function closeNav() {
	$('.nav-wrap').removeClass('nav-active');
	$('.nav-opener').removeClass('is-active');
}

function coverPage() {
	var CoverElement = '<div class="pageCover" onclick="closeNav()"></div>';
	if ($('.pageCover').length < 1) {
		$('body').addClass('pageLock');
		$(CoverElement).prependTo('body').fadeIn();
	}
}


function removePageCover() {
	$('.pageCover').fadeOut(function () {
		$(this).remove()
	});
	$('body').removeClass('pageLock')
}

// Dropdown Boxes Script

// mobile sub menu drop down
$('.sub-opener').click(function () {
	var $parent_box = $(this).closest('.hassub');
	$parent_box.find('> .sub-menu-wrap, > .sub-sub-menu-wrap').stop().slideToggle(500, 'swing');
	$parent_box.toggleClass('open');

	$(this).toggleClass('minus');
});

// drop down CE
$('.dropdown-opener').click(function () {
	toggleDropdown($(this).closest('.dropdown-wrap'));
});

function toggleDropdown($dropdownWrap) {
	if ($dropdownWrap.hasClass('open')) {
		closeDropdown($dropdownWrap);
	} else {
		openDropdown($dropdownWrap);
	}
}

function openDropdown($dropdownWrap) {
	$dropdownWrap.find('.dropdown-content').stop().slideDown(500, 'swing');
	$dropdownWrap.addClass('open');
	$dropdownWrap.find('.plus').addClass('minus');
}

function closeDropdown($dropdownWrap) {
	$dropdownWrap.find('.dropdown-content').stop().slideUp(500, 'swing');
	$dropdownWrap.removeClass('open');
	$dropdownWrap.find('.plus').removeClass('minus');
}

function closeDropdownOnMobile() {
	var $dropdownWraps = $('.dropdown-wrap.preopen');

	if (window.innerWidth <= breakpointMobile) {
		$dropdownWraps.each(function (i, dropdownWrap) {
			var $dropdownWrap = $(dropdownWrap);
			var headerContentsArray = Array.from($dropdownWrap.find('.dropdown-opener .frame'));
			var isContentEmpty = headerContentsArray.filter(function (headerContent) {
				return isEmpty(headerContent).length === headerContentsArray.length;
			});
			if (isContentEmpty) {
				return;
			}
			$dropdownWrap.removeClass('preopen');
			closeDropdown($dropdownWrap);
		})
	} else {
		$('.dropdown-wrap').each(function (i, dropdown) {
			var $dropdown = $(dropdown);
			if ($dropdown.attr('data-is-preopened') === 'true') {
				$dropdown.addClass('preopen');
				if ($dropdown.hasClass('open')) {
					return;
				}
				openDropdown($dropdown);
			}
		})
	}
}

// fancyBox
$('[data-fancybox]').fancybox({
	// Options will go here
	buttons: [
		'slideShow',
		'fullScreen',
		'thumbs',
		'close'
	]
});

// Slider Configurations

$('.emo-img-slider').slick({
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	prevArrow: "<div class='slider-arrow slick-prev'><div class='arrow'></div></div>",
	nextArrow: "<div class='slider-arrow slick-next'><div class='arrow'></div></div>",
	lazyLoad: 'anticipated',
});

const slickSliderOptions = {
	infinite: true,
	slidesToShow: 3,
	slidesToScroll: 3,
	prevArrow: "<div class='slider-arrow slick-prev'><div class='arrow'></div></div>",
	nextArrow: "<div class='slider-arrow slick-next'><div class='arrow'></div></div>",

	responsive: [
		{
			breakpoint: 1100,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			}
		},
		{
			breakpoint: 650,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			}
		},
	]
}
$('.slider').slick(slickSliderOptions);

// Animated Navigation Functions
var scrollTop = 0;
$(window).scroll(function () {
	scrollTop = $(window).scrollTop();
	$('.counter').html(scrollTop);

	if (scrollTop >= 100) {
		$('.page-nav').addClass('scrolled');
		$('body').addClass('page-is-scrolled ');
		updateAnchorNavPosition();
	} else if (scrollTop < 100) {
		$('.page-nav').removeClass('scrolled');
		$('body').removeClass('page-is-scrolled ');
		resetAnchorNavPosition();
	}
});

var didScroll;
var lastScrollTop = 0;
var scrollDirections = {up: 'UP', down: 'DOWN'};
var currentScrollDirection = scrollDirections.down;
var delta = 5;
var navbarHeight = 0;

$(window).scroll(function (event) {
	didScroll = true;
});

setInterval(function () {
	if (didScroll) {
		hasScrolled();
		didScroll = false;
	}
}, 250);

function hasScrolled() {
	var st = $(this).scrollTop();

	// Make sure they scroll more than delta
	if (Math.abs(lastScrollTop - st) <= delta)
		return;

	// If they scrolled down and are past the navbar, add class .scrolled-nav.
	if (st > lastScrollTop && st > navbarHeight) {
		// Scroll Down
		currentScrollDirection = scrollDirections.down;
		$('.sub-page-logo').addClass('scrolled');
	} else {
		// Scroll Up
		currentScrollDirection = scrollDirections.up;
		if (st + $(window).height() < $(document).height()) {
			$('.sub-page-logo').removeClass('scrolled');
		}
	}

	lastScrollTop = st;
}

// Animated Content Navigation Script
$('.content-navigation li').hover(function () {
	var pageid = $(this).data('page');
	$('.animated-img-container').find('.' + pageid).toggleClass('visible');
});

// responsive tables
const breakpointResponsiveTables = 768;
var $tables = $('table.ce-table');

$tables.each(function (i, table) {
	var $table = $(table);

	if ($table.find('tbody td').length <= 1) {
		return;
	}

	if ($table.closest('.frame-type-table').hasClass('frame-layout-400')) {
		return;
	}

	$table.basictable(
		{
			breakpoint: breakpointResponsiveTables,
		}
	)
})

function updateTable() {
	if (window.innerWidth <= breakpointResponsiveTables) {

		if ($tables.length <= 0) {
			return;
		}

		$('.ce-table.bt tbody td:first-of-type').each(function (i, firstLine) {
			var dataTh = $(firstLine).attr('data-th').trim();
			if (dataTh.length > 0) {
				$(firstLine).addClass('has-content-in-first-row');
			}
		});

	} else {
		$('.ce-table.bt tbody td:first-of-type').each(function (i, firstLine) {
			$(firstLine).removeClass('has-content-in-first-row');
		})
	}
}


// for print
window.addEventListener("beforeprint", function (e) {
	$('.slider').slick('unslick');

	$('.content-change').each(function (i, contentChange) {
		var $tab = $(contentChange),
			$tabTitle = $tab.find('.page-text').clone(true),
			dataPage = $tab.attr('data-page'),
			$tabContent = $('.pagecontent.' + dataPage + '');

		$tabTitle.addClass('js-added-title-for-print');
		$tabContent.prepend($tabTitle);
	})

	$('.dropdown-wrap').addClass('open');
});

window.addEventListener("afterprint", function (e) {
	$('.slider').slick(slickSliderOptions);
	$('.js-added-title-for-print').remove();
	$('.dropdown-wrap:not(.preopen)').addClass('open');
});


/**
 *
 */
function handlePreselectionOfJobSelect() {
	// get preselected value
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const preselectedOptionId = urlParams.get('preselectedoptionid');

	if (!preselectedOptionId) {
		return;
	}
	// get select field
	let $preselectedOption = $(`select#powermail_field_bewerbungals option[value=${preselectedOptionId}]`);

	// select option of select
	if ($preselectedOption.length > 0) {
		$preselectedOption.prop('selected', true);
	}

	// update all values of select fields for output in mail
	$('select option').each(function () {
		let $option = $(this);
		$option.attr('value',$option.text());
	})

}

function updateAnchorNavPosition() {
	// Only apply for desktop viewport (> 1637px)
	if (window.innerWidth > 1637) {
		let $anchorNav = $('.anchor-nav');
		if ($anchorNav.length > 0) {
			// Get the first direct child wrapper in body (excluding navigation and overlay elements)
			let $firstWrapper = $('.outer-wrapper');

			if ($firstWrapper.length > 0) {
				// Get the distance from top of viewport to the wrapper
				let wrapperOffsetTop = $firstWrapper.offset().top;

				let scrollPosition = $(window).scrollTop();
				let distanceToTop = wrapperOffsetTop - scrollPosition;

				// Only apply fixed positioning when wrapper has reached or passed the top (distance <= 0)
				if (distanceToTop <= 0) {
					// Use same calculation as scrollToHash for consistency
					let offset = calculateAnchorOffset();

					// Set the top position dynamically
					$anchorNav.css('top', offset + 'px');
				} else {
					// Wrapper hasn't reached top yet, reset to default CSS positioning
					$anchorNav.css('top', '');
				}
			}
		}
	}
}

function resetAnchorNavPosition() {
	// Reset to CSS default when not scrolled
	if (window.innerWidth > 1637) {
		$('.anchor-nav').css('top', '');
	}
}


